import type { FC } from "react";
import { useMemo } from "react";

import { SobQuiz as UiSobQuiz } from "@jti/ui/components/SobQuiz";

import { type InputQuestion, transformSobData } from "./utils/transformSobData";

import type { sobQuizInputs } from "./SobQuiz.builder";

export type SobQuestionsBuilderReferenceResponse = {
  value?: {
    data?: {
      questions: InputQuestion[];
    };
  };
};

export type SobQuizProps = Override<
  BuilderComponentProps<typeof sobQuizInputs>,
  { questions?: SobQuestionsBuilderReferenceResponse }
>;

export const SobQuiz: FC<SobQuizProps> = ({
  finalScreen,
  consentCaptureQuestion,
  questionScreen,
  questions,
  type = "SOURCE_OF_BUSINESS",
  uuid,
}) => {
  const {
    answerDimensions,
    questionDimensions,
    quizTransitions,
    uuid: customUuid,
  } = useMemo(() => {
    return transformSobData(questions?.value?.data?.questions, uuid);
  }, [questions?.value?.data?.questions, uuid]);

  return (
    <UiSobQuiz
      data={{
        finalScreen,
        consentCaptureQuestion,
        questionScreen,
        type,
        quizTransitions,
        answerDimensions,
        questionDimensions,
        uuid: customUuid,
      }}
    />
  );
};
